import { LOAN_STATUS } from "../../../config";

export const DISABLED_LOAN_STATUS = [
  LOAN_STATUS.STATUS_CANCELLED,
  LOAN_STATUS.STATUS_CANCELLED_TEST,
  LOAN_STATUS.STATUS_DESISTED,
  LOAN_STATUS.STATUS_EXPIRED,
];
